<template>
  <div class="inside-bg dashboard-page">
    <div class="container dashboard-page__container">
      <nav aria-label="breadcrumb" class="hc-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="/">Home</a></li>
          <li class="breadcrumb-item active" aria-current="page">My profile</li>
        </ol>
      </nav>

      <div
        class="dashboard-sidebar-overlay"
        :class="{ 'dashboard-sidebar-overlay--open': sidebarOpen }"
        aria-hidden="true"
        @click="mbar_close"
      />

      <div
        class="sidebar dashboard-sidebar"
        id="mySidebar"
        :class="{ 'dashboard-sidebar--open': sidebarOpen }"
        @click.stop
      >
        <DashboardNav
          variant="mobile"
          :selected-tab="selectedTab"
          :profile-completion-percent="profileCompletionPercent"
          @select-tab="selectTab"
          @open-completion="openProfileCompletion"
          @close="mbar_close"
        />
      </div>

      <div class="row dashboard-page__layout">
        <div class="col-lg-9 dashboard-page__main">
          <ProfileHeader
            :user="user"
            :user_loading="user_loading"
            :user_city="user_city"
            :user_state="user_state"
            :designation="designation"
            :visume="visume"
            :visume_path="visume_path"
            :resume_path="resume_path"
            @open-visume="openModal('visume')"
            @upload-resume="upload('resume')"
            @open-completion="openProfileCompletion"
            @verify-email="goToEmailSettings"
          />

          <div class="tab-content shadow rounded-lg hc-panel-wrap" id="v-pills-tabContent">
            <JobDetails :user="user" v-if="selectedTab=='jobDetails'"/>
            <ScheduledInterviews :user="user" v-if="selectedTab=='scheduledInterviews'"/>
            <Assessments :user="user" v-if="selectedTab=='assessments'"/>
            <Comments :user="user" v-if="selectedTab=='comments'"/>
            <PersonalDetails :user="user" v-if="selectedTab=='personalDetails'"/>
            <EducationDetails :user="user" v-if="selectedTab=='educationalDetails'"/>
            <ExperienceDetails :user="user" v-if="selectedTab=='experienceDetails'"/>
            <CallLetter :user="user" v-if="selectedTab=='selectCallLeter'"/>
            <FAQ :user="user" v-if="selectedTab=='selectFAQ'"/>
            <ProfileViewers :user="user" v-if="selectedTab=='profile_viewers'"/>
            <Settings :user="user" v-if="selectedTab=='selectSettings'"/>
          </div>
        </div>
        <div class="col-lg-3 mb-5 m-hide dashboard-page__sidebar">
          <div class="hc-sidenav-wrap shadow rounded-lg">
            <DashboardNav
              variant="desktop"
              :selected-tab="selectedTab"
              :profile-completion-percent="profileCompletionPercent"
              @select-tab="selectTab"
              @open-completion="openProfileCompletion"
            />
          </div>
        </div>
      </div>
      <VisumeModal :visume="user.personal_details.video_resume_path" :open="visumeModal.open" v-if="user.personal_details"/>
      <b-modal
        centered
        id="profile_alert"
        ref="profile-alert"
        hide-footer
        hide-header
        modal-class="hc-modal"
        content-class="hc-modal__content"
        body-class="hc-modal__body p-0"
      >
        <div class="hc-modal__profile">
          <div class="hc-modal__profile-header">
            <button type="button" class="hc-modal__close" @click="closeModal('profile-alert')" aria-label="Close">&times;</button>
            <h2 class="hc-modal__profile-title">Complete your profile</h2>
            <p class="hc-modal__profile-subtitle">Profiles with 80% or more completion are shortlisted more often.</p>
            <div class="hc-modal__score-wrap">
              <div class="hc-modal__score-ring" :style="{ '--score-pct': profileCompletionPercent }">
                <span>{{ profileCompletionPercent }}%</span>
              </div>
              <div class="hc-modal__score-meta">
                <strong>{{ profileCompletionPercent >= 80 ? 'Great progress!' : `${80 - profileCompletionPercent}% to go` }}</strong>
                <div class="hc-modal__score-bar">
                  <div class="hc-modal__score-bar-fill" :style="{ width: profileCompletionPercent + '%' }"></div>
                </div>
              </div>
            </div>
          </div>
          <ul class="hc-modal__checklist">
            <li
              v-for="item in profileCompletionChecklist"
              :key="item.id"
              class="hc-modal__checklist-item"
              :class="item.done ? 'is-done' : 'is-pending'"
            >
              <i class="mdi" :class="item.done ? 'mdi-check-circle' : item.icon" aria-hidden="true"></i>
              <div class="hc-modal__checklist-text">
                <span>{{ item.label }}</span>
                <small v-if="!item.done">+{{ item.maxPoints }} pts</small>
              </div>
              <span v-if="item.done" class="hc-modal__checklist-done">Done</span>
              <button
                v-else
                type="button"
                class="hc-modal__checklist-btn"
                @click="handleChecklistAction(item)"
              >
                {{ item.actionLabel }}
              </button>
            </li>
          </ul>
          <div class="hc-modal__footer">
            <button type="button" class="hc-modal__btn hc-modal__btn--ghost" @click="closeModal('profile-alert')">Skip for now</button>
            <button type="button" class="hc-modal__btn hc-modal__btn--primary" @click="goToNextIncomplete">Continue</button>
          </div>
        </div>
      </b-modal>
      <b-modal
        centered
        ref="upload-resume"
        hide-footer
        hide-header
        modal-class="hc-modal"
        content-class="hc-modal__content"
        body-class="hc-modal__body p-0"
      >
        <div class="hc-modal__panel">
          <div class="hc-modal__panel-header">
            <button type="button" class="hc-modal__close hc-modal__close--dark" @click="closeModal('upload-resume')" aria-label="Close">&times;</button>
            <h2 class="hc-modal__panel-title">Upload resume</h2>
            <p class="hc-modal__panel-subtitle">PDF, DOC, DOCX or RTF — max 10 MB.</p>
          </div>
          <div class="hc-modal__panel-body">
            <v-form ref="form" lazy-validation v-model="valid">
              <v-file-input
                :accept="resumeAccept"
                v-model="resume"
                placeholder="Choose resume file"
                append-icon="mdi-file"
                prepend-icon=""
                :rules="resumeFileRules"
                show-size
                outlined
              ></v-file-input>
              <div v-if="resumeUploadError" class="error-feedback">{{ resumeUploadError }}</div>
            </v-form>
          </div>
          <div class="hc-modal__footer">
            <button type="button" class="hc-modal__btn hc-modal__btn--ghost" @click.prevent="closeModal('upload-resume')">Cancel</button>
            <button type="button" class="hc-modal__btn hc-modal__btn--primary" @click.prevent="uploadResume()" :disabled="loading">
              {{ loading ? 'Uploading…' : 'Save resume' }}
            </button>
          </div>
        </div>
      </b-modal>
      <button
        type="button"
        class="dashboard-menu-fab"
        @click.stop="mbar_toggle"
        :aria-expanded="sidebarOpen ? 'true' : 'false'"
        aria-controls="mySidebar"
        aria-label="Open profile menu"
      >
        <i class="mdi mdi-menu" aria-hidden="true"></i>
        <span class="dashboard-menu-fab__text">Menu</span>
      </button>
      <ProfileToast ref="profileToast" />
    </div>
    <b-modal
      id="send-otp-modal"
      centered
      hide-footer
      hide-header
      modal-class="hc-modal"
      content-class="hc-modal__content"
      body-class="hc-modal__body p-0"
    >
      <div class="hc-modal__panel">
        <div class="hc-modal__panel-header">
          <button type="button" class="hc-modal__close hc-modal__close--dark" @click="$bvModal.hide('send-otp-modal')" aria-label="Close">&times;</button>
          <h2 class="hc-modal__panel-title">Verify mobile</h2>
          <p class="hc-modal__panel-subtitle">Secure your account with a one-time password sent to your phone.</p>
        </div>
        <div class="hc-modal__panel-body">
          <b-form ref="login-form">
            <div class="form-label-group" v-if="!mobileFormHidden">
              <label class="hc-modal__field-label" for="mobile">Mobile number</label>
              <div class="hc-modal__input-row">
                <input
                  id="mobile"
                  v-model="form.mobile"
                  ref="mobile"
                  :disabled="disableEdit"
                  type="text"
                  placeholder="Enter your mobile"
                  :class="{'is-invalid': typeof validate.response.tel != 'undefined' && !validate.response.tel.val}"
                  class="form-control hc-modal__input"
                  @input="validate.mobileValidation(form.mobile, 'tel')"
                />
                <button type="button" class="hc-modal__icon-btn" @click="disableEdit = !disableEdit" aria-label="Edit mobile">
                  <v-icon class="mdi" size="1.1rem" color="#6c757d">{{ $icons.pencilCircleOutline }}</v-icon>
                </button>
              </div>
              <div class="invalid-feedback d-block" v-if="typeof validate.response.tel != 'undefined' && !validate.response.tel.val">{{ validate.response.tel.msg }}</div>
              <div class="invalid-feedback d-block" v-if="otpError !== '' && otpError !== 'limit_exceeded'">{{ otpError }}</div>
              <div class="invalid-feedback d-block" v-if="otpError == 'limit_exceeded'">Too many attempts. Write to <a href="mailto:recruit@hireclap.com" target="_blank">recruit@hireclap.com</a> to verify your mobile.</div>
            </div>
            <div v-if="mobileFormHidden">
              <label class="hc-modal__field-label">Enter OTP</label>
              <div class="hc-modal__otp-row" ref="otp-input">
                <input id="otp_1" v-on:keyup="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.focus()" v-model="form.otp.otp_1" ref="otp_1" type="text" class="form-control hc-modal__otp" maxlength="1" inputmode="numeric"/>
                <input id="otp_2" v-on:keyup="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.previousElementSibling.focus()" v-model="form.otp.otp_2" ref="otp_2" type="text" class="form-control hc-modal__otp" maxlength="1" inputmode="numeric"/>
                <input id="otp_3" v-on:keyup="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.previousElementSibling.focus()" v-model="form.otp.otp_3" ref="otp_3" type="text" class="form-control hc-modal__otp" maxlength="1" inputmode="numeric"/>
                <input id="otp_4" v-on:keyup.delete="$event.target.previousElementSibling.focus()" v-model="form.otp.otp_4" ref="otp_4" type="text" class="form-control hc-modal__otp" maxlength="1" inputmode="numeric"/>
              </div>
              <div class="invalid-feedback d-block" v-if="otpError !== '' && mobileFormHidden">{{ otpError }}</div>
            </div>
          </b-form>
        </div>
        <div class="hc-modal__footer">
          <button v-if="!mobileFormHidden" type="button" class="hc-modal__btn hc-modal__btn--primary hc-modal__btn--block" @click="sendOtp($event)">Send OTP</button>
          <button v-if="mobileFormHidden" type="button" class="hc-modal__btn hc-modal__btn--primary hc-modal__btn--block" @click="verifyOtp">Verify OTP</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import '../assets/hire.css';
import '../assets/site-chrome.css';
import '../assets/jobs-list-page.css';
import AwsUpload from "../../utils/s3upload"
import validation from '../libraries/validFormat' ;
import profileCompletionMixin from '@/mixins/profileCompletionMixin';
import ProfileHeader from '@/components/Dashboard/ProfileHeader.vue';
import ProfileToast from '@/components/Dashboard/ProfileToast.vue';
import DashboardNav from '@/components/Dashboard/DashboardNav.vue';

import Actions from '../libraries/apiActions.js';
import { eventBus } from '@/main';
import { consumeVisumeFeedback } from '@/utils/visumeFeedback';
import {
  RESUME_ACCEPT,
  isValidResumeFile,
  resumeValidationMessage,
  buildResumeS3Key,
} from '@/utils/resumeUpload';
import { mapState, mapGetters } from 'vuex';
import store from '../store';
import { COURSES } from '../store/modules/courses/constants';
import { STATES } from '../store/modules/states/constants';
import { JOB_ROLE } from '../store/modules/jobrole/constants';
import { DESIGNATIONS } from '../store/modules/designations/constants';
// import { ContentLoader } from 'vue-content-loader';

const VisumeModal = () => import(/* webpackPrefetch: true */ "@/components/VisumeModal");
const JobDetails = () => import(/* webpackPrefetch: true */ "@/components/JobDetails");
const PersonalDetails = () => import(/* webpackPrefetch: true */ "@/components/PersonalDetails");
const EducationDetails = () => import(/* webpackPrefetch: true */ "@/components/EducationDetails");
const ExperienceDetails = () => import(/* webpackPrefetch: true */ "@/components/ExperienceDetails");
const CallLetter = () => import(/* webpackPrefetch: true */ "@/components/CallLetter");
const Faq = () => import(/* webpackPrefetch: true */ "@/components/FAQ");
const Settings = () => import(/* webpackPrefetch: true */ "@/components/Settings");
const ScheduledInterviews = () => import(/* webpackPrefetch: true */ "@/components/ScheduledInterviews");
const Assessments = () => import(/* webpackPrefetch: true */ "@/components/Assessments");
const Comments = () => import(/* webpackPrefetch: true */ "@/components/Comments");
const ProfileViewers = () => import(/* webpackPrefetch: true */ "@/components/ProfileViewers");

var breadcrumbJson = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": window.location.origin
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Profile",
        "item": window.location.href
      }]
    }
export default {
  name: "dashboard",
  mixins: [profileCompletionMixin],
  components:{
    ProfileHeader,
    ProfileToast,
    DashboardNav,
    'JobDetails': JobDetails,
    'PersonalDetails': PersonalDetails,
    'EducationDetails': EducationDetails,
    'ExperienceDetails': ExperienceDetails,
    'CallLetter': CallLetter,
    'ScheduledInterviews':ScheduledInterviews,
    'Assessments': Assessments,
    'FAQ': Faq,
    'Settings': Settings,
     VisumeModal,
     Comments,
     ProfileViewers
    //  ContentLoader
  },
  data() {
    return {
      validate: new validation(),
      selectedTab:'jobDetails',
      visumeModal:{
        open:'exit',
      },
      token: null,
      user: {},
      user_city: {},
      user_state: null,
      user_career: null,
      visume:'',
      visume_path:'',
      selectJob:true,
      selectPersonal:false,
      selectEducation:false, 
      selectExperience:false,
      selectCallLeter:false,
      selectFAQ:false,
      selectSettings:false,
      profileImage:null,
      selectedFile:null,
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos',
      designation:null,
      action:new Actions(),
      resume_path:null,
      resume: null,
      resumeAccept: RESUME_ACCEPT,
      resumeUploadError: '',
      update:{
        resume:null
      },
      valid:true,
      loading:false,
      user_loading:true,
      form: {
        mobile: 0,
        otp: {
          otp_1: "",
          otp_2: "",
          otp_3: "",
          otp_4: "",
        },
      },
      disableEdit: true,
      mobileFormHidden: false,
      validateError: false,
      otpError: "",
      sidebarOpen: false,
    }
  },
  async beforeMount() {
    window.scrollTo(0, 0);
    const seeker = this.$cookies.get('hire-seeker');
    this.token = seeker ? seeker.token : null;
    if (!this.token) {
      this.user_loading = false;
      return;
    }
    await this.getUser();
        if(this.user){
          this.form.mobile = this.user.mobile;
        }
        if(this.user&&this.$cookies.get('hire-seeker').alert =='yes'&&(!this.resume_path || !this.visume_path)){
          this.$refs['profile-alert'].show();
        }
        if(this.$route.query.tab) {
          this.selectTab(this.$route.query.tab, false);
        } else {
          this.selectTab('jobDetails', false);
        }
  },
  metaInfo: (vue) => {
    const user = vue.user;
    const user_city = vue.user_city;
    return {
      script: [
        {type: 'application/ld+json', json: breadcrumbJson},
        {
          type: "application/ld+json",
          json: {
            "@context": "http://schema.org/",
            "@type": "PersonSchema",
            name: `${user ? user.name : ""}`,
            email: `${user ? user.email: ""}`,
            mobile: `${user ? user.mobile : ""}`,
            gender: `${user&&user.personal_details ? (user.personal_details.gender==1?'Male':(user.personal_details.gender==2?'Female':'Other')) : ""}`,
            course: `${user&&user.high_qualification&&user.high_qualification.course ? user.high_qualification.course.course_name : ""}`,
            branch: `${user&&user.high_qualification&&user.high_qualification.branch ? user.high_qualification.branch.branch_name : ""}`,
            userLocation: user_city.city_name,
            userLocationRequirements: {
              "@type": "Country",
              name: 'India',
            },
          },
        }
      ],
    };
  },
  beforeCreate() {
      this.$store = store;
  },
  created() {
    const apiFn = this.action;
    this.cachedDispatch(COURSES.GET_COURSE, { param: apiFn });
    this.cachedDispatch(STATES.GET_STATES, { param: apiFn });
    this.cachedDispatch(JOB_ROLE.GET_JOB_ROLE, { param: apiFn });
    this.cachedDispatch(DESIGNATIONS.GET_DESIGNATIONS, { param: apiFn });
  },
  computed: {
    ...mapGetters(['cachedDispatch']),
    ...mapState({
        courses: state => state.courses.courses.courses,
        locations: state => state.states.locations.locations,
        jobrole: state => state.jobrole.jobrole.jobrole,
        designations : state => state.designations.designations.designations
    }),
    resumeFileRules() {
      return [
        (v) => !!v || 'Upload valid resume',
        (v) => {
          if (!v) return true;
          const result = isValidResumeFile(v);
          return result.valid || resumeValidationMessage(result.reason);
        },
      ];
    },
  },
  beforeDestroy() {
    document.body.classList.remove('dashboard-sidebar-open');
  },
  mounted() {
    this.showVisumeFeedback();
  },
  methods: {
    showVisumeFeedback() {
      const feedback = consumeVisumeFeedback();
      if (!feedback) return;
      this.$nextTick(() => {
        const toast = this.$refs.profileToast;
        if (!toast) return;
        if (feedback.type === 'success') {
          const duration = feedback.duration;
          const message = duration > 0
            ? `Visume saved (${duration}s). Recruiters can view it on your profile.`
            : 'Visume saved. Recruiters can view it on your profile.';
          toast.show(message, 'success', { duration: 6000 });
        } else if (feedback.type === 'error' && feedback.message) {
          toast.show(feedback.message, 'danger', { duration: 8000 });
        }
      });
    },
    openProfileCompletion() {
      if (this.profileCompletionPercent >= 80) {
        this.selectTab('personalDetails');
        return;
      }
      this.$refs['profile-alert'].show();
    },
    handleChecklistAction(item) {
      this.$refs['profile-alert'].hide();
      if (item.action === 'visume') {
        this.upload('visume');
        return;
      }
      if (item.action === 'resume') {
        this.upload('resume');
        return;
      }
      if (item.action === 'otp') {
        this.openOtpModal();
        return;
      }
      if (item.action) {
        this.selectTab(item.action);
      }
    },
    goToNextIncomplete() {
      const nextItem = this.profileCompletionChecklist.find((item) => !item.done);
      if (nextItem) {
        this.handleChecklistAction(nextItem);
        return;
      }
      this.closeModal('profile-alert');
      this.selectTab('personalDetails');
    },
    openModal : function(type= ''){
      this.open = type == "" ? this.open : type;
      if (this.open == "profile-pic") {
        this.$refs["profile-pic"].show();
      }
        this.visumeModal.open = 'exit';
        this.visumeModal.open = type;
    },
    closeModal(data){
      this.$refs[data].hide();
      if(data == 'profile-alert'){
        let cookie = this.$cookies.get('hire-seeker');
        let updated_cookie = {token:cookie.token,name:cookie.name,visume_path:cookie.visume_path,resume_path:cookie.resume_path,alert:'no'};
        this.$cookies.remove("hire-seeker");
        this.$cookies.set("hire-seeker",updated_cookie);
      }
    },
    resetModal() {},
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    openOtpModal() {
       this.$refs['profile-alert'].hide();
      this.mobileFormHidden = false;
      this.validateError = false;
      this.otpError = "";
      this.$bvModal.show("send-otp-modal");
    },
    sendOtp(e) {
      e.preventDefault();
      this.validateError = false;
      this.otpError = "";
      const mobileCheck = this.validate.mobileValidation(this.form.mobile, "tel");
      if (mobileCheck?.val === false) {
        this.validateError = true;
        return;
      }
      const token = this.$cookies.get("hire-seeker")?.token;
      if (!token) {
        this.otpError = "Session expired. Please log in again.";
        return;
      }
      const data = {
        input: {
          mobile: this.form.mobile,
        },
        token,
      };
      this.action.sendOtp(data).then((res) => {
        if (res.status) {
          this.mobileFormHidden = true;
          this.otpError = "";
        } else {
          this.otpError = res.message;
        }
      }).catch(() => {
        this.otpError = "Unable to send OTP. Please check your connection and try again.";
      });
    },
    verifyOtp() {
      let token = this.$cookies.get("hire-seeker").token;
      let otp =
        this.form.otp.otp_1 +
        this.form.otp.otp_2 +
        this.form.otp.otp_3 +
        this.form.otp.otp_4;
      let data = {
        input: {
          mobile: this.form.mobile,
          otp: otp,
        },
        token: token,
      };
      this.action.verifyOtp(data).then((res) => {
        if (res.status) {
          this.getUser();
          this.$bvModal.hide("send-otp-modal");
          this.showMsgModal('You have successfully verified your mobile number');
          this.mobileFormHidden = true;
        } else {
          this.otpError = res.message;
        }
      });
    },
    showMsgModal(msg = null) {
      this.boxOne = '';
      this.$bvModal.msgBoxOk(msg, {
          buttonSize: 'sm',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
      });
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
    async getUser() {
      await this.action.getUser(this.$cookies.get("hire-seeker").token ).then(async (data) => {
        if (data) {
          this.user_loading = false;
          this.user = data.user;
          this.user_details = this.user?.personal_details
          this.user_city = data.user?.personal_details?.user_city;
          this.user_state = this.user_city?.state?.state_name;
          this.user_career = this.user?.careerPreferencesDetail;
          this.visume = data.user?.personal_details?.video_resume_path;
          this.visume_path = data.user?.personal_details?.video_resume_path || '';
          this.resume_path = data.user?.personal_details?.resume_path;
          const cookie = this.$cookies.get('hire-seeker');
          if (cookie) {
            this.$cookies.set('hire-seeker', {
              ...cookie,
              visume_path: this.visume_path || cookie.visume_path,
              resume_path: this.resume_path || cookie.resume_path,
            });
            eventBus.$emit('seeker-updated');
          }
          await this.$store.state.jobrole.jobrole.jobrole.forEach((role) => {
            if(role.value == this.user_career.fst_prefered_role){
              this.designation = role.text;
            }
          })
        } else { 
          // this.$router.replace("/").catch(() => {});
        }
      }).catch((err) => {
        console.log(err);
        if (err) {
          // this.$router.replace("/").catch(() => {});
        }
      });
    },
    changeActive(e){
      e.preventDefault()
      var elems = document.querySelectorAll(".active");
        [].forEach.call(elems, function(el) {
          el.classList.remove("active");
        });
        e.target.classList.add('active')
    },
    goToEmailSettings() {
      this.selectTab('selectSettings');
    },
    selectTab(tab, syncRoute = true){
      if(!tab) return;
      this.mbar_close();
      this.selectedTab = tab;
      if (syncRoute && this.$route.query.tab !== tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } }).catch(() => {});
      }
    },
    filesChange(event) {
      this.selectedFile = event.target.files[0];
    },
    mbar_toggle() {
      this.sidebarOpen = !this.sidebarOpen;
      document.body.classList.toggle('dashboard-sidebar-open', this.sidebarOpen);
    },
    mbar_open() {
      this.sidebarOpen = true;
      document.body.classList.add('dashboard-sidebar-open');
    },
    mbar_close() {
      this.sidebarOpen = false;
      document.body.classList.remove('dashboard-sidebar-open');
    },

    upload(data){
      this.$refs['profile-alert'].hide();
      if(data == 'visume'){
        this.openModal('visume');
      }else if(data == 'resume'){
        this.$refs['upload-resume'].show();
      }
    },
    async uploadResume(){
      let token = this.$cookies.get("hire-seeker").token;
      this.resumeUploadError = '';
      this.valid = this.$refs.form.validate();
      if(this.valid == true){
        const resumeCheck = isValidResumeFile(this.resume);
        if (!resumeCheck.valid) {
          this.resumeUploadError = resumeValidationMessage(resumeCheck.reason);
          return;
        }

        this.loading = true;
        const file = this.resume;
        const awsUploader = new AwsUpload();
        try {
          const filename = buildResumeS3Key(this.user?.name, file);
          const response = await awsUploader.uploadToS3(file, filename);
          if (!response?.url) {
            throw new Error('Upload response missing URL');
          }
          this.update.resume = response.url;
          this.action.updateResume(this.update.resume,token).then(data =>{
            if(data.message == "Resume Updated"){
              this.loading = false;
              this.resume = false;
              this.$refs['upload-resume'].hide();
              let cookie = this.$cookies.get('hire-seeker');
              let updated_cookie = {token:cookie.token,name:cookie.name,visume_path:cookie.visume_path,resume:'yes',resume_path:this.update.resume};
              this.$cookies.remove("hire-seeker");
              this.$cookies.set("hire-seeker",updated_cookie);
              location.reload();
            }else{
              this.loading = false;
              this.resumeUploadError = 'Resume update failed. Please try again.';
            }
          }).catch(err =>{
            this.loading = false;
            this.resumeUploadError = 'Resume update failed. Please try again.';
            console.log(err);
          })
        } catch (error) {
          this.loading = false;
          this.resumeUploadError = 'Resume upload failed. Check your connection and try again.';
          console.error('Failed to upload file to S3:', error);
        }
      }
    }

  },
};
</script>